import { IconStyle, LoaderType, Tag, TagStyle, TagWidth, Theme, useTranslation } from '@nextgen-web-framework/all';
import { FC } from 'react';
import { CustomTag } from '@commerce-product-webcomponents/ui';
import { ITagsContainer } from './types/propsTypes';
import styles from './CartCardComponentV2.module.scss';

const TagsContainer: FC<ITagsContainer> = ({
  subscriptionTagText,
  showApointTag,
  showCompensatedSOPTag,
  showPromotionTag,
  showSubscriptionTag,
  showPromotionBenefitTag,
  promotionBenefitTagText,
}) => {
  const t = useTranslation();
  return (
    <>
      {showPromotionTag && (
        <Tag
          className={styles['promotion-tag']}
          icon={{
            iconName: 'tags',
          }}
          style={TagStyle.SOLID}
          tagWidth={TagWidth.FIT_CONTENT}
          text=""
          theme={Theme.SUCCESS}
        />
      )}
      {showPromotionBenefitTag && (
        <CustomTag
          loaderType={LoaderType.WEBFONTS}
          isRelativeURL
          alt={t('product.TagsContainer.promotionBenefitTag')}
          src="/icons/gift-white.svg"
          width={14}
          height={14}
          text={promotionBenefitTagText}
        />
      )}
      {showSubscriptionTag && (
        <>
          <Tag
            text={subscriptionTagText}
            style={TagStyle.SOLID}
            theme={Theme.PURPLE}
            icon={{ iconName: 'refresh', iconStyle: IconStyle.REGULAR }}
          />
          {showCompensatedSOPTag && (
            <Tag
              text={t('product.common.compensated')}
              style={TagStyle.OUTLINE}
              theme={Theme.PURPLE}
              icon={{ iconName: 'bolt', iconStyle: IconStyle.REGULAR }}
            />
          )}
        </>
      )}
      {showApointTag && (
        <Tag
          text={t('product.common.Apoint')}
          style={TagStyle.OUTLINE}
          theme={Theme.PURPLE}
          icon={{ iconName: 'money-bills-simple', iconStyle: IconStyle.REGULAR }}
        />
      )}
    </>
  );
};

export default TagsContainer;
